<template>
  <!-- site-wrapper START here -->
  <div id="site-wrapper">
    <sts-header />
    <router-view />
    <sts-footer />
  </div>
</template>

<script>
import StsFooter from "./StsFooter";
import StsHeader from "./StsHeader";
export default {
  components: {
    StsFooter,
    StsHeader,
  },
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("getStoredUser");
    this.$store.dispatch("getFreePicks");
    this.$store.dispatch("getSports");
    this.$store.dispatch("getPackages");
    this.$store.dispatch("getCategories");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// Shell.vue?01c9f614